import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { subscriptionLinkResponseSchema } from "@/domains/subscriptions/models/schemas";

export const subscriptionQueryOptions = createQueryKeys("subscription", {
  link: {
    queryKey: null,
    queryFn: () => {
      return getSubscriptionLink();
    },
  },
});

const getSubscriptionLink = async () => {
  const response = await privateApi.get("/subscriptions/link");

  return createServiceResponseSchema(subscriptionLinkResponseSchema).parse(response.data).data;
};
